// Helper function to process video accessibility for a container
function processVideoAccessibility(container, containerName) {
  const lsVideo = container.querySelector('#ls-video');
  
  if (lsVideo && !lsVideo.hasAttribute('aria-labelledby')) {
    lsVideo.setAttribute('aria-labelledby', 'ls-detail-caption');
    
    const lsDetailCaption = document.querySelector('.ls-detail-caption');
    if (lsDetailCaption) {
      lsDetailCaption.setAttribute('id', 'ls-detail-caption');
    }
  }
}

// Function to handle accessibility attributes
function handleLsVideoAccessibility() {
  const containers = [
    { selector: '#ls-slider-popup-container', name: '#ls-slider-popup-container' },
    { selector: '#ls-popup-container', name: '#ls-popup-container' }
  ];
  
  containers.forEach(({ selector, name }) => {
    const container = document.querySelector(selector);
    if (container) {
      processVideoAccessibility(container, name);
    }
  });
}

// Watch for #ls-slider-popup-container
const lsSliderObserver = new MutationObserver((mutations) => {
  handleLsVideoAccessibility();
});

lsSliderObserver.observe(document.body, {
  childList: true,
  subtree: true
});

// Update Flickity page dots aria-labels from 'Page dot' to 'Slide'
function updateFlickityDotsAriaLabels() {
  const dots = document.querySelectorAll('.flickitylf-page-dots .dot');
  dots.forEach((dot) => {
    const ariaLabel = dot.getAttribute('aria-label');
    if (ariaLabel && ariaLabel.includes('Page dot')) {
      dot.setAttribute('aria-label', ariaLabel.replace('Page dot', 'Slide'));
    }
  });
}

// Run on page load
updateFlickityDotsAriaLabels();

// Watch for dynamically added dots
let flickityDotsUpdateScheduled = false;
const flickityDotsObserver = new MutationObserver(() => {
  if (flickityDotsUpdateScheduled) return;
  flickityDotsUpdateScheduled = true;
  requestAnimationFrame(() => {
    flickityDotsUpdateScheduled = false;
    updateFlickityDotsAriaLabels();
  });
});

flickityDotsObserver.observe(document.body, {
  childList: true,
  subtree: true
});

// Add focus class to kt-image-item-box when kt-image-link is focused
function setupImageLinkFocus() {
  document.querySelectorAll('.kt-image-link, .kt-image-lightbox').forEach((link) => {
    if (link.dataset.focusListenerAdded) return;
    link.dataset.focusListenerAdded = 'true';
    
    link.addEventListener('focus', () => {
      const parent = link.closest('.kt-image-item-box');
      if (parent) parent.classList.add('has-focus-within');
    });
    
    link.addEventListener('blur', () => {
      const parent = link.closest('.kt-image-item-box');
      if (parent) parent.classList.remove('has-focus-within');
    });
  });
}

// Run on page load
setupImageLinkFocus();

// Watch for dynamically added links
const imageLinkObserver = new MutationObserver(() => {
  setupImageLinkFocus();
});

imageLinkObserver.observe(document.body, {
  childList: true,
  subtree: true
});


